import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const AnalysisModal = ({ outputText, show , setShow}) => {

  const handleClose = () => setShow(false);

  return (
    <>


      <Modal show={show} onHide={handleClose} size="lg" centered dir="rtl" style={{backdropFilter: 'blur(10px)',zIndex:13000}}>
        <Modal.Header closeButton>
          <Modal.Title>פירוש הגרפים והתמהילים</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ whiteSpace: 'pre-line' }}>
          <div className="explanations" dangerouslySetInnerHTML={{ __html: outputText || "לא התקבל ניתוח בשלב זה." }} />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            סגור
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AnalysisModal;
